module.exports = __webpack_public_path__ + "static/media/footerBrandLogo.574f7328.png";